import React from 'react';

// The history overview's car: side view on the 800 x 300 map, front on the left. It keeps the outline's proportions
// (wheels at x 175 and 618, roof from 326 to 630) so the zone pins in view/format.js land on the same parts.
export const CarSide = ({ children }) => (
    <>
        <defs>
            <linearGradient id="hc-body" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#3A3170" />
                <stop offset="0.55" stopColor="#211B45" />
                <stop offset="1" stopColor="#120F29" />
            </linearGradient>
            <linearGradient id="hc-glass" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#8FA0FF" stopOpacity="0.55" />
                <stop offset="1" stopColor="#2B2F63" stopOpacity="0.9" />
            </linearGradient>
            <linearGradient id="hc-rim" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#E6E8F2" />
                <stop offset="1" stopColor="#7B7F99" />
            </linearGradient>
            <radialGradient id="hc-shadow" cx="0.5" cy="0.5" r="0.5">
                <stop offset="0" stopColor="#000000" stopOpacity="0.55" />
                <stop offset="1" stopColor="#000000" stopOpacity="0" />
            </radialGradient>
            <radialGradient id="hc-light" cx="0.5" cy="0.5" r="0.5">
                <stop offset="0" stopColor="#FFF6C9" />
                <stop offset="1" stopColor="#FFF6C9" stopOpacity="0" />
            </radialGradient>
        </defs>
        <ellipse cx="398" cy="268" rx="350" ry="16" fill="url(#hc-shadow)" />
        <path
            d="M44,214 C44,186 58,160 92,154 L248,134 C276,112 304,92 330,80 C340,74 350,72 362,72 L586,72 C606,72 620,78 632,90 L688,148 C724,156 746,172 750,196 L752,214 C752,220 748,224 742,224 L52,224 C47,224 44,220 44,214 Z"
            fill="url(#hc-body)"
            stroke="#A7A1DD"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path d="M266,132 L334,86 L452,86 L452,132 Z" fill="url(#hc-glass)" />
        <path d="M466,86 L584,86 Q600,86 612,98 L646,132 L466,132 Z" fill="url(#hc-glass)" />
        <line x1="92" y1="146" x2="700" y2="146" stroke="#FFFFFF" strokeOpacity="0.18" strokeWidth="2" />
        <line x1="60" y1="176" x2="744" y2="176" stroke="#E83E8C" strokeOpacity="0.75" strokeWidth="2" />
        <line x1="459" y1="134" x2="459" y2="218" stroke="#FFFFFF" strokeOpacity="0.18" strokeWidth="1.5" />
        <line x1="262" y1="138" x2="262" y2="218" stroke="#FFFFFF" strokeOpacity="0.12" strokeWidth="1.5" />
        <rect x="404" y="154" width="26" height="5" rx="2.5" fill="#CFD2E6" fillOpacity="0.7" />
        <rect x="512" y="154" width="26" height="5" rx="2.5" fill="#CFD2E6" fillOpacity="0.7" />
        <ellipse cx="56" cy="172" rx="30" ry="16" fill="url(#hc-light)" />
        <path d="M50,166 L86,160 L88,176 L52,182 Z" fill="#FFF6C9" />
        <path d="M734,162 L746,166 L748,190 L732,190 Z" fill="#E83E8C" />
        <circle cx="175" cy="222" r="49" fill="#0D0B21" />
        <circle cx="618" cy="222" r="49" fill="#0D0B21" />
        <circle cx="175" cy="222" r="42" fill="#07060F" stroke="#FFFFFF" strokeOpacity="0.25" strokeWidth="2" />
        <circle cx="618" cy="222" r="42" fill="#07060F" stroke="#FFFFFF" strokeOpacity="0.25" strokeWidth="2" />
        <circle cx="175" cy="222" r="26" fill="url(#hc-rim)" />
        <circle cx="618" cy="222" r="26" fill="url(#hc-rim)" />
        <g stroke="#4B4F6A" strokeWidth="5" strokeLinecap="round">
            <line x1="175" y1="222" x2="175.0" y2="198.0" />
            <line x1="175" y1="222" x2="197.8" y2="214.6" />
            <line x1="175" y1="222" x2="189.1" y2="241.4" />
            <line x1="175" y1="222" x2="160.9" y2="241.4" />
            <line x1="175" y1="222" x2="152.2" y2="214.6" />
            <line x1="618" y1="222" x2="618.0" y2="198.0" />
            <line x1="618" y1="222" x2="640.8" y2="214.6" />
            <line x1="618" y1="222" x2="632.1" y2="241.4" />
            <line x1="618" y1="222" x2="603.9" y2="241.4" />
            <line x1="618" y1="222" x2="595.2" y2="214.6" />
        </g>
        <circle cx="175" cy="222" r="7" fill="#E83E8C" />
        <circle cx="618" cy="222" r="7" fill="#E83E8C" />
        {/* the selected area's highlight, over the car */}
        {children}
    </>
);
